import { map, Observable } from 'rxjs';
import {
  AuthService, IconAction, IMPERSONATION_SESSION_STORAGE_KEY, User,
  UserStatus,
} from '@nimmsta/ng-commons-lib';

export class ImpersonateAction extends IconAction<User> {
  constructor(
    _text: string,
    private authService: AuthService,
    _secondaryIcon?: string,
  ) {
    super(_text, 'swap_horiz', false, undefined, _secondaryIcon);
  }

  override isEnabled(user: User): Observable<boolean> {
    return this.authService.getCurrentUser().pipe(map(
      (currentUser) => currentUser.email !== user.email
        && user.status === UserStatus.ACTIVE // only allow active users to be impersonated
        && sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) === null,
    ));
  }
}
